import { ref } from 'vue'
import { pgMessage } from '../../message/index'
import { http } from '../../../utils/index'

export function useSure({ formData, submitUrl, submitMethod, successTip, submitParam }) {
  const pgFormRef = ref(null)
  const sureLoading = ref(false)
  const sure = async () => {
    const error = await pgFormRef.value.validate()
    if (error) {
      pgMessage.error('请完善必填信息')
    } else if (!submitUrl.value) {
      return formData.value
    } else {
      sureLoading.value = true
      const param =
        typeof submitParam.value == 'function'
          ? submitParam.value(formData.value)
          : Object.assign({}, formData.value, submitParam.value)
      const [res] = await http[submitMethod.value](submitUrl.value, param, {
        successTip,
      }).catch(() => (sureLoading.value = false))
      sureLoading.value = false
      if (res) {
        return res
      }
    }
  }

  const validate = async () => {
    const error = await pgFormRef.value.validate()
    if (error) {
      pgMessage.error('请完善必填信息')
      return error
    }
  }

  return {
    pgFormRef,
    sureLoading,
    sure,
    validate,
  }
}
